import React, { PropTypes, Component } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import FaqList from 'common/components/faqs';

export default class Faqs extends Component {
  componentDidMount() {
    this.props.fetchAllFaqsIfNeeded();
  }

  render() {
    const { data, isLoading } = this.props;

    if (isLoading) {
      return <LoadingIndicator />;
    }

    if (!data || !data.length) {
      return null;
    }

    return (<div className="small-16 columns">
      <h2 className="help-category-type">Frequently asked questions</h2>
      <FaqList data={data} />
    </div>);
  }
}

Faqs.propTypes = {
  fetchAllFaqsIfNeeded: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  data: PropTypes.array,
};



// WEBPACK FOOTER //
// ./help/components/faqs.jsx